"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AjvError () {
        return AjvError;
    },
    get NcErrorV1 () {
        return NcErrorV1;
    },
    get NcZodError () {
        return NcZodError;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _extractLimitAndOffset = require("~/helpers/extractLimitAndOffset");
const _acl = require("~/utils/acl");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
let AjvError = class AjvError extends _nocodbsdk.NcBaseError {
    constructor(param){
        super(param.message);
        this.errors = param.errors;
        this.humanReadableError = param.humanReadableError || false;
    }
};
let NcZodError = class NcZodError extends _nocodbsdk.NcBaseErrorv2 {
    constructor(param){
        super(param.message, 400, _nocodbsdk.NcErrorType.ERR_INVALID_REQUEST_BODY, {
            details: param.errors
        });
        this.errors = Array.isArray(param.errors) ? param.errors : [
            param.errors
        ];
    }
};
let NcErrorV1 = class NcErrorV1 extends _nocodbsdk.NcErrorBase {
    permissionDenied(permissionName, roles, extendedScopeRoles) {
        throw this.errorCodex.generateError(_nocodbsdk.NcErrorType.ERR_PERMISSION_DENIED, {
            customMessage: (0, _acl.generateReadablePermissionErr)(permissionName, roles, extendedScopeRoles),
            details: {
                permissionName,
                roles,
                extendedScopeRoles
            }
        });
    }
    recordNotFound(id, args) {
        let formatedId = '';
        if (!id) {
            formatedId = 'unknown';
        } else if (typeof id === 'string') {
            formatedId = [
                id
            ];
        } else if (typeof id === 'number') {
            formatedId = [
                id.toString()
            ];
        } else if (Array.isArray(id)) {
            if (id.every((i)=>typeof i === 'string')) {
                formatedId = id;
            } else {
                formatedId = id.map((val)=>{
                    const idsArr = Object.values(val);
                    if (idsArr.length > 1) {
                        return idsArr.map((idVal)=>{
                            var _idVal_toString;
                            return idVal == null ? void 0 : (_idVal_toString = idVal.toString) == null ? void 0 : _idVal_toString.call(idVal).replaceAll('_', '\\_');
                        }).join('___');
                    } else if (idsArr.length) {
                        return idsArr[0];
                    } else {
                        return 'unknown';
                    }
                });
            }
        } else {
            const idsArr = Object.values(id);
            if (idsArr.length > 1) {
                formatedId = idsArr.map((idVal)=>{
                    var _idVal_toString;
                    return idVal == null ? void 0 : (_idVal_toString = idVal.toString) == null ? void 0 : _idVal_toString.call(idVal).replaceAll('_', '\\_');
                }).join('___');
            } else if (idsArr.length) {
                formatedId = idsArr[0];
            } else {
                formatedId = 'unknown';
            }
        }
        throw this.errorCodex.generateError(_nocodbsdk.NcErrorType.ERR_RECORD_NOT_FOUND, _extends({
            params: formatedId
        }, args));
    }
    ajvValidationError(param) {
        throw new AjvError(param);
    }
    zodError(param) {
        throw new NcZodError(param);
    }
    invalidRequestBody(message) {
        // backward compatibility for v1 and v2 apis
        return this.badRequest(message);
    }
    sourceDataReadOnly(name) {
        return this.forbidden(`Source '${name}' is read-only`);
    }
    sourceMetaReadOnly(name) {
        return this.forbidden(`Source '${name}' schema is read-only`);
    }
    schemaLocked(message) {
        return this.forbidden(message || 'Schema modifications are not allowed on managed apps');
    }
    constructor(){
        super();
        this.errorCodex.setErrorCodex(_nocodbsdk.NcErrorType.ERR_INVALID_LIMIT_VALUE, {
            message: `Limit value should be between ${_extractLimitAndOffset.defaultLimitConfig.limitMin} and ${_extractLimitAndOffset.defaultLimitConfig.limitMax}`,
            code: 422
        });
    }
};
